module.exports = __webpack_public_path__ + "img/teamImg4.52ecdadc.jpg";